<template>
  <CardFrame :bgColor="data.backgroundColor" hasDropShadow>
    <CardContainer>
      <CardHeaderContainer :layout="'inline'">
        <Title class="'text-center'" :headingTag="'h3'" :style="'h4'">
          {{ data.title }}
        </Title>
      </CardHeaderContainer>
      <Hr isEmbedded />
      <CardBodyContainer>
        <CardBody :textAlignment="'left'" :textSize="'small'" :text="data.body">
        </CardBody>
      </CardBodyContainer>
    </CardContainer>
  </CardFrame>
</template>

<script>
import CardContainer from "../../Atoms/Cards/CardContainer.vue";
import CardHeaderContainer from "../../Atoms/Cards/CardHeaderContainer.vue";
import CardBodyContainer from "../../Atoms/Cards/CardBodyContainer.vue";
import CardBody from "../../Atoms/Cards/CardBody.vue";
import CardFrame from "../../Atoms/Cards/CardFrame.vue";
import Hr from "../../Atoms/Hr.vue";
import Title from "../../Atoms/Heading.vue";

export default {
  components: {
    CardBody,
    CardBodyContainer,
    CardContainer,
    CardHeaderContainer,
    CardFrame,
    Hr,
    Title,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
